import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
import useLogin from "hooks/useLogin";

const ProtectedRoute = (props) => {
  const {
    component: Component,
    accessCondition,
    redirectPath = "/dashboard",
    ...rest
  } = props;
  const { isLogged } = useLogin();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (accessCondition === true) {
          return <Component {...props} />;
        } else if (accessCondition === false && isLogged === true) {
          return <Redirect to={redirectPath} />;
        } else {
          return <Redirect to={"/"} />;
        }
      }}
    />
  );
};

ProtectedRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  accessCondition: PropTypes.bool.isRequired,
  redirectPath: PropTypes.string,
  rest: PropTypes.object,
};

export default ProtectedRoute;
